export const formatFileSize = (fileSize: number): string => {
  let size = fileSize / 1024;
  let suffix = 'KB';

  if (size >= 1024) {
    size = size / 1024;
    suffix = 'MB';
  }

  return `${size.toFixed(1)} ${suffix}`;
};
